import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot } from '@angular/router';
import { IdentityService } from '../identity.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard {
    constructor(
        private readonly identityService: IdentityService,
        public router: Router
    ) {}

    async canActivate(_: ActivatedRouteSnapshot): Promise<boolean> {
        await firstValueFrom(this.identityService.isAuthenticated$);
        if (!this.identityService.hasOAuth || !this.identityService.current) {
            const targetPath = this.identityService.getCurrentLocationPath();
            if (!this.identityService.loginPages.some((p) => targetPath.startsWith(p))) {
                this.router.navigate(['/signin'], { queryParams: { target: targetPath || undefined } });
            }
            return false;
        }
        return true;
    }
}
